import React, { useEffect, useState } from 'react';
import greenTick from '../../assets/icons/ads_tick.svg';
import shopify from '../../assets/icons/shopify_ad_icon.png';
import meta from '../../assets/icons/meta_ad_icon.png';
import googleAds from '../../assets/icons/google_ad_icon.png';
import linkedIn from '../../assets/icons/linked_ad_icon.png';
import bing from '../../assets/icons/bing_ad_icon.png';
import tiktok from '../../assets/icons/tiktok_ad_icon.png';
import { useGetIntegrations } from '../../apiHooks/queries/integrations/allIntegrations/useGetAllIntegrations';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ShopifyPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const { data, refetch, isFetching } = useGetIntegrations('GET_ALL_INTEGRATIONS');
    const integrations = data?.data?.data || {};

    const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
        let interval: any;
        let stopTime: any;

        const params = new URLSearchParams(location.search);
        if (params.get('integration_redirect')) {
            refetch();

            interval = setInterval(() => refetch(), 2000);
            stopTime = setTimeout(() => clearInterval(interval), 10000);

            window.history.replaceState({}, '', location.pathname);
        }

        return () => {
            clearInterval(interval);
            clearTimeout(stopTime);
        };
    }, [location.search]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const connectedParam = params.get('connected');

        if (connectedParam === 'shopify') {
            setShowSuccess(true);

            refetch();

            const newUrl = location.pathname;
            window.history.replaceState({}, '', newUrl);
        } else {
            refetch();
        }
    }, [location.search, location.pathname, refetch]);

    const renderAdBox = (
        name: string,
        icon: string,
        integrationKey: any,
        path: string,
        border?: boolean
    ) => {
        const isConnected = integrations[integrationKey];
        return (
            <div
                onClick={() => navigate(path)}
                className={`relative flex items-center gap-3 border-t ${
                    border ? 'border-b' : ''
                } py-3 min-w-[254px] hover:cursor-pointer`}
            >
                <img
                    src={icon}
                    alt={name}
                    className={`h-[42px] border p-2 rounded-xl w-[42px] ${
                        isConnected ? 'border-[#4C956C] border-2' : ''
                    }`}
                />
                <span className="text-sm">{name}</span>
                {isConnected && (
                    <div className="bg-white flex items-center gap-2 ml-4 text-sm text-primary rounded-tr-lg rounded-bl-lg p-1">
                        <img src={greenTick} alt={""} />
                        {t('connectedBadge')}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="flex flex-start gap-6 mt-6">
            <div className="bg-white flex flex-col justify-between rounded-xl max-w-[588px] w-full p-6 shadow-sm">
                <div>
                    <h2 className="text-primary font-bold text-xl mb-2">{t('connectedHeading')}</h2>
                    <p className="text-sm leading-relaxed text-primary mb-6">
                        <strong>{t('connectedWhatsNext')}</strong>
                        <br />
                        {t('shopifyThankYou')}
                        <br />
                        {t('shopifyConnectDescription')}
                        <br />
                        {t('shopifyConnectRecommendation')}
                        <br />
                        {t('shopifyConnectAccuracy')}
                        <br />
                        {t('shopifyConnectRequirement')}
                        <br />
                        {t('shopifyConnectCta')}
                    </p>
                </div>

                <div className="flex items-center gap-3 border rounded-lg w-full border-[#4C956C] px-4 py-3 w-fit">
                    <img src={shopify} alt="Shopify" className="h-[32px] w-[52px]" />
                    <p className="text-base text-primary">{t('shopify')}</p>
                    {showSuccess && (
                        <div className="bg-white rounded-tr-lg rounded-bl-lg p-1 ml-auto text-primary flex items-center gap-2 text-sm">
                            <img src={greenTick} alt={""} />
                            {t('successfullyConnected')}
                        </div>
                    )}
                </div>
            </div>

            <div className="bg-white rounded-xl w-full max-w-[588px] p-6 shadow-sm">
                <h2 className="text-primary font-bold text-xl mb-2">
                    {t('shopifyProviderHeading')}
                </h2>
                <p className="text-sm text-primary leading-relaxed mb-4">
                    {t('shopifyProviderIntro')}
                    <br />
                    {t('shopifyProviderFlexibility')}
                    <br />
                    {t('shopifyNavigationHint', { integrations: t('integrations'), adProviders: t('ad-providers') })}
                </p>

                <div className="flex flex-wrap justify-between mt-4">
                    {renderAdBox('Meta', meta, 'facebook', '/integrations/ad-providers/facebook')}
                    {renderAdBox(
                        'LinkedIn',
                        linkedIn,
                        'linkedin',
                        '/integrations/ad-providers/linked-in'
                    )}
                    {renderAdBox(
                        'Google',
                        googleAds,
                        'google',
                        '/integrations/ad-providers/google'
                    )}
                    {renderAdBox(
                        'TikTok',
                        tiktok,
                        'tiktok',
                        '/integrations/ad-providers/tik-tok',
                        true
                    )}
                    {renderAdBox(
                        'Bing',
                        bing,
                        'microsoft',
                        '/integrations/ad-providers/bing',
                        true
                    )}
                </div>
            </div>
        </div>
    );
};

export default ShopifyPage;
